/**
 * The web API turned a change down. `refusal` is its own code — `not-an-admin`, `name-taken` and
 * the rest — which `describeRefusal` puts into words. `body` is the whole answer, for a refusal
 * that carries more than its code.
 */
export class Refused extends Error {
  constructor(
    readonly refusal: string,
    readonly body?: unknown,
  ) {
    super(refusal)
  }
}
